import { Component, Element, Prop, State, Watch, h } from '@stencil/core';
import hljs from 'highlight.js';
@Component({
  tag: 'code-snippet',
  styleUrl: 'code-snippet.css',
  shadow: true,
})
export class CodeSnippet {
  @Prop() code: string;
  @Prop() copyButtonText: string = 'Copy';
  @Prop() copiedButtonText: string = 'Copied!';
  @Prop() language: string;

  @State() copied: boolean = false;

  @Element() el: HTMLElement;

  @Watch('code')
  handleCodeUpdate() {
    this.highlightCode();
  }

  componentDidLoad() {
    this.highlightCode();
  }

  highlightCode() {
    if (
      this.language &&
      this.language.startsWith('language-') &&
      this.language != 'language-html' &&
      this.code
    ) {
      this.el.shadowRoot.querySelectorAll('pre code').forEach((block) => {
        if (block.getAttribute('data-highlighted')) {
          block.textContent = this.code;
          block.removeAttribute('data-highlighted');
        }
        block.setAttribute('class', this.language);
        hljs.highlightElement(block as HTMLElement);
      });
    }
  }

  copyCode() {
    navigator.clipboard.writeText(this.code);
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }

  render() {
    return (
      <div class="code-snippet" part="container">
        <div class="code-snippet__header" part="header">
          <span>{this.language ? this.language.replace('language-', '') : 'Code'}</span>
          <button class="copy-button" part="copy-button" onClick={() => this.copyCode()}>
            {this.copied ? (
              <span class="copy-button__container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-check"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>{' '}
                {this.copiedButtonText}
              </span>
            ) : (
              <span class="copy-button__container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-copy"
                >
                  <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                  <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                </svg>{' '}
                {this.copyButtonText}
              </span>
            )}
          </button>
        </div>
        <pre class="code-snippet__content" part="code">
          <code>{this.code}</code>
        </pre>
      </div>
    );
  }
}
